import { type FC, type PropsWithChildren, useEffect } from "react";

import { useGlobalSettings } from "~/api/queries/useGlobalSettings";
import { useTheme } from "~/modules/Theme";

export const ThemeWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { setColorSchema } = useTheme();
  const { data: globalSettingsData, isSuccess } = useGlobalSettings();

  useEffect(() => {
    if (isSuccess && globalSettingsData?.primaryColor && globalSettingsData?.contrastColor) {
      setColorSchema(globalSettingsData.primaryColor, globalSettingsData.contrastColor);
    }
  }, [isSuccess, globalSettingsData, setColorSchema]);

  return <>{children}</>;
};
